import { memo, useMemo } from 'react';
import Select, { type StylesConfig } from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../../../components/modal/MemberModal';

export type SchedulePrintCategoryOption = {
  value: number;
  label: string;
};

type SchedulePrintCategoryPickerProps = {
  categoryOptions: SchedulePrintCategoryOption[];
  listCategoryIds: number[] | null;
  onChange: (listCategoryIds: number[] | null) => void;
};

export const SchedulePrintCategoryPicker = memo(function SchedulePrintCategoryPicker({
  categoryOptions,
  listCategoryIds,
  onChange,
}: SchedulePrintCategoryPickerProps) {
  const { t } = useTranslation();
  const prefix = 'creativeDetail-';

  const selectedValues = useMemo(() => {
    if (!listCategoryIds?.length) return [];
    const idSet = new Set(listCategoryIds);
    return categoryOptions.filter((option) => idSet.has(option.value));
  }, [categoryOptions, listCategoryIds]);

  if (categoryOptions.length === 0) return null;

  return (
    <div className="schedule-print-category-picker mb-3">
      <div className="schedule-print-category-picker__title fw-semibold mb-2">
        {t(prefix + 'schedulePrintListCategoriesTitle')}
      </div>
      {selectedValues.length === 0 ? (
        <p className="text-muted small mb-2">{t(prefix + 'schedulePrintListCategoriesAll')}</p>
      ) : null}
      <Select<SchedulePrintCategoryOption, true>
        isMulti
        options={categoryOptions}
        value={selectedValues}
        onChange={(selected) => {
          const next = selected?.map((option) => option.value) ?? [];
          onChange(next.length > 0 ? next : null);
        }}
        placeholder={t(prefix + 'schedulePrintListCategoriesPlaceholder')}
        styles={customStyles as StylesConfig<SchedulePrintCategoryOption, true>}
        classNamePrefix="react-select"
      />
    </div>
  );
});
